import React from "react";
import { Link, graphql } from "gatsby";
import Helmet from "react-helmet";
import Layout from "../components/layout";
import ProductListItem from "../components/ProductListItem";
import SEO from "../components/seo";
import homeStyles from "../styles/home.module.css";
import "../styles/home.css";
import ArrowDecor from "../components/home/ArrowDecor";
import Header from "../components/Header";
import Footer from "../components/Footer";

const HomePageTemplate = ({ data, pageContext, location }) => {
  const page = data.markdownRemark.frontmatter;
  const siteTitle = data.site.siteMetadata.title;
  const siteUrl = data.site.siteMetadata.siteUrl;
  const { previous, next } = pageContext;
  const blogs = data.blog.edges

  const products = data.allMarkdownRemark.edges;
  console.log("productz", products, page, 'blog', blogs);

  // const products = page.products
  // console.log("products", products)

  return (
    <Layout location={location} title={siteTitle}>
      <Helmet
        bodyAttributes={{
          class: "site-layout--landing bg-image bg-fixed appear-animate",
        }}
      />
      {/* <Header /> */}

        <div class="page-loader dark">
            <div class="loader">Loading...</div>
        </div>

        <a href="#main" class="btn skip-to-content">Skip to Content</a>

        <div class="page bg-dark light-content" id="top">


            <nav class="main-nav dark transparent stick-fixed wow-menubar">
                <div class="full-wrapper relative clearfix">


                    <div class="nav-logo-wrap local-scroll">
                        <a href="#" class="logo">
                            <img src="/asset/images/huxlogo_white.png" alt="Company logo"/>
                        </a>
                    </div>


                    <div class="mobile-nav" role="button" tabindex="0">
                        <i class="fa fa-bars"></i>
                        <span class="sr-only">Menu</span>
                    </div>


                    <a href="/asset/shop-cart-dark.html" class="mobile-cart"><i class="main-nav-icon-cart"></i> (0)</a>


                    <div class="inner-nav desktop-nav">
                        <ul class="clearlist">
                            <li class="d-sm-none d-md-none d-lg-block">
                                <a href="/"><i class="fas fa-home"></i> Home</a>
                            </li>
                            <li class="d-sm-none d-md-none d-lg-block">
                                <a href="/about"><i class="fas fa-dice-d20"></i> About</a>
                            </li>
                            <li class="d-sm-none d-md-none d-lg-block">
                                <a href={page.tokopediaUrl}><i class="main-nav-icon-cart"></i> Shop</a>
                            </li>
                            <li class="d-sm-none d-md-none d-lg-block">
                                <a href="/#tutorial"><i class="fas fa-spa"></i> Tutorial</a>
                            </li>
                            <li class="d-sm-none d-md-none d-lg-block">
                                <a href="/#blog"><i class="fas fa-book-open"></i> Blog</a>
                            </li>

                            {/* <li>
                                <a href="#" class="mn-has-sub active">Home <i class="mn-has-sub-icon"></i></a>


                                <ul class="mn-sub mn-has-multi">


                                    <li class="mn-sub-multi">
                                        <a class="mn-group-title" href="/asset/intro-dark.html#multi-page">Multi Page</a>

                                        <ul>
                                            <li>
                                                <a href="/asset/mp-index-dark.html">Main Demo</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Image Parallax 1 🚫</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-02-dark.html">Image Parallax 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-03-dark.html">Image Parallax 3</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-04-dark.html">Image Parallax 4</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-06-dark.html">Image Parallax 5</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-12-dark.html">Fullwidth Image</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-05-dark.html">Text Rotator</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-15-dark.html">Typed Text</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-07-dark.html">Slider Fullscreen</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-08-dark.html">Slider Zoom Effect</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-09-dark.html">Slider Fullwidth</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-10-dark.html">Slider Background</a>
                                            </li>
                                        </ul>

                                    </li>



                                    <li class="mn-sub-multi">
                                        <a class="mn-group-title">&nbsp;</a>

                                        <ul>
                                            <li>
                                                <a href="/asset/mp-index-17-dark.html">Slider Animation 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-18-dark.html">Slider Animation 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-20-dark.html">Content Slider</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-11-dark.html">With Play Button</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-13-dark.html">BG Video Fullwidth</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-14-dark.html">BG Video Fullscreen</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-19-dark.html">BG HTML5 Video</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-23-dark.html">Floating Image</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-24-dark.html">Floating Images</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-21-dark.html">Wave Edge</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-22-dark.html">Round Edge</a>
                                            </li>
                                            <li>
                                                <a href="/asset/mp-index-16-dark.html">Agency Header</a>
                                            </li>
                                            <li>
                                                <a href="/asset/intro.html">Light Version <span class="label-new round">Hot</span></a>
                                            </li>
                                        </ul>

                                    </li>




                                    <li class="mn-sub-multi">
                                        <a class="mn-group-title" href="/asset/intro-dark.html#one-page">One Page</a>

                                        <ul>
                                            <li>
                                                <a href="/asset/index-dark.html">Main Demo</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Image Parallax 1 🚫</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-02-dark.html">Image Parallax 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-03-dark.html">Image Parallax 3</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-04-dark.html">Image Parallax 4</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-06-dark.html">Image Parallax 5</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-12-dark.html">Fullwidth Image</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-05-dark.html">Text Rotator</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-15-dark.html">Typed Text</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-07-dark.html">Slider Fullscreen</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-08-dark.html">Slider Zoom Effect</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-09-dark.html">Slider Fullwidth</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-10-dark.html">Slider Background</a>
                                            </li>
                                        </ul>

                                    </li>



                                    <li class="mn-sub-multi">
                                        <a class="mn-group-title">&nbsp;</a>

                                        <ul>
                                            <li>
                                                <a href="/asset/index-17-dark.html">Slider Animation 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-18-dark.html">Slider Animation 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-20-dark.html">Content Slider</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-11-dark.html">With Play Button</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-13-dark.html">BG Video Fullwidth</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-14-dark.html">BG Video Fullscreen</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-19-dark.html">BG HTML5 Video</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-23-dark.html">Floating Image</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-24-dark.html">Floating Images</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-21-dark.html">Wave Edge</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-22-dark.html">Round Edge</a>
                                            </li>
                                            <li>
                                                <a href="/asset/index-16-dark.html">Agency Header</a>
                                            </li>
                                            <li>
                                                <a href="/asset/intro.html">Light Version <span class="label-new round">Hot</span></a>
                                            </li>
                                        </ul>

                                    </li>


                                </ul>


                            </li>



                            <li>
                                <a href="#" class="mn-has-sub">Pages <i class="mn-has-sub-icon"></i></a>


                                <ul class="mn-sub mn-has-multi">

                                    <li class="mn-sub-multi">
                                        <a class="mn-group-title">Group 1</a>

                                        <ul>
                                            <li>
                                                <a href="/asset/pages-about-1-dark.html">About Us 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-about-2-dark.html">About Us 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-about-3-dark.html">About Us 3</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-services-1-dark.html">Services 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-services-2-dark.html">Services 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-services-3-dark.html">Services 3</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-clients-dark.html">Clients</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-landing-dark.html">Landing Page</a>
                                            </li>
                                        </ul>

                                    </li>

                                    <li class="mn-sub-multi">
                                        <a class="mn-group-title">Group 2</a>

                                        <ul>
                                            <li>
                                                <a href="/asset/pages-team-1-dark.html">Team 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-team-2-dark.html">Team 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-faq-1-dark.html">FAQ 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-faq-2-dark.html">FAQ 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-pricing-1-dark.html">Pricing 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-pricing-2-dark.html">Pricing 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-contact-1-dark.html">Contact 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-contact-2-dark.html">Contact 2</a>
                                            </li>
                                        </ul>

                                    </li>

                                    <li class="mn-sub-multi">
                                        <a class="mn-group-title">Group 3</a>

                                        <ul>
                                            <li>
                                                <a href="/asset/pages-gallery-1col-dark.html">Gallery Col 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-gallery-2col-dark.html">Gallery Col 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-gallery-3col-dark.html">Gallery Col 3</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-gallery-4col-dark.html">Gallery Col 4</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-gallery-6col-dark.html">Gallery Col 6</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-account-dark.html">Login / Register</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-under-construction-dark.html">Under Construction</a>
                                            </li>
                                            <li>
                                                <a href="/asset/pages-404-dark.html">Error 404</a>
                                            </li>
                                        </ul>

                                    </li>

                                </ul>


                            </li>



                            <li>
                                <a href="#" class="mn-has-sub">Elements <i class="mn-has-sub-icon"></i></a>


                                <ul class="mn-sub mn-has-multi">

                                    <li class="mn-sub-multi">

                                        <ul>
                                            <li>
                                                <a href="/asset/elements-accordions-dark.html"><i class="fa fa-plus-circle fa-sm"></i> Accordions</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-animation-dark.html"><i class="fa fa-play fa-sm"></i> Animation</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-bars-dark.html"><i class="fa fa-tachometer-alt fa-sm"></i> Bars (Progress)</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-buttons-dark.html"><i class="fa fa-link fa-sm"></i> Buttons</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-features-dark.html"><i class="fa fa-th-large fa-sm"></i> Features Box</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-forms-dark.html"><i class="fa fa-align-justify fa-sm"></i> Form Fields</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-grid-dark.html"><i class="fa fa-th fa-sm"></i> Grid</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-iconmonstr-dark.html"><i class="far fa-heart fa-sm"></i> Icons Iconmonstr</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-icons-fa-dark.html"><i class="fa fa-heart fa-sm"></i> Icons Font Awesome</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-images-lazyload-dark.html"><i class="fa fa-spinner fa-sm"></i> Images Lazyload</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-lightbox-dark.html"><i class="fa fa-id-card fa-sm"></i> Lightbox</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-messages-dark.html"><i class="fa fa-comment fa-sm"></i> Messages</a>
                                            </li>
                                        </ul>

                                    </li>

                                    <li class="mn-sub-multi">

                                        <ul>
                                            <li>
                                                <a href="/asset/elements-page-titles-dark.html"><i class="fa fa-feather fa-sm"></i> Page Titles</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-sliders-dark.html"><i class="fa fa-chevron-circle-right fa-sm"></i> Sliders</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-sliders-lazyload-dark.html"><i class="fa fa-chevron-circle-right fa-sm"></i> Sliders Lazyload</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-tabs-dark.html"><i class="fa fa-columns fa-sm"></i> Tabs</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-typography-dark.html"><i class="fa fa-font fa-sm"></i> Typography</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-video-sound-dark.html"><i class="fab fa-youtube fa-sm"></i> Video / Sound</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-header-dark-dark.html"><i class="fa fa-h-square fa-sm"></i> Header Dark</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-header-dark-transparent-dark.html"><i class="fa fa-h-square fa-sm"></i> Header Dark Transp</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-header-white.html" title="Isn't available in the dark version"><i class="fa fa-h-square fa-sm"></i> H-r White 🚫</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-header-white-transparent.html" title="Isn't available in the dark version"><i class="fa fa-h-square fa-sm"></i> H-r White Transp 🚫</a>
                                            </li>
                                            <li>
                                                <a href="/asset/elements-header-white-after-scroll.html" title="Isn't available in the dark version"><i class="fa fa-h-square fa-sm"></i> H-r Scroll-White 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                </ul>


                            </li>



                            <li>
                                <a href="#" class="mn-has-sub">Portfolio <i class="mn-has-sub-icon"></i></a>


                                <ul class="mn-sub">

                                    <li>
                                        <a href="#" class="mn-has-sub">Boxed <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-boxed-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-4col-dark.html">4 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-5col-dark.html">5 Columns</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Black Hovers 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Boxed (Gutter) <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-boxed-gutter-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-gutter-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-gutter-4col-dark.html">4 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-gutter-5col-dark.html">5 Columns</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Black Hovers 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Boxed (Titles) <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-boxed-titles-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-titles-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-titles-4col-dark.html">4 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-boxed-titles-5col-dark.html">5 Columns</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Black Hovers 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Wide <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-wide-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-4col-dark.html">4 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-5col-dark.html">5 Columns</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Black Hovers 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Wide (Gutter) <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-wide-gutter-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-gutter-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-gutter-4col-dark.html">4 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-gutter-5col-dark.html">5 Columns</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Black Hovers 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Wide (Titles) <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-wide-titles-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-titles-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-titles-4col-dark.html">4 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-wide-titles-5col-dark.html">5 Columns</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Black Hovers 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Masonry <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-masonry-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-masonry-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-masonry-4col-dark.html">4 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-masonry-5col-dark.html">5 Columns</a>
                                            </li>
                                            <li>
                                                <a href="#" title="Isn't available in the dark version">Black Hovers 🚫</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Single <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/portfolio-single-1-dark.html">Single 1</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-single-2-dark.html">Single 2</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-single-3-dark.html">Single 3</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-single-4-dark.html">Single 4</a>
                                            </li>
                                            <li>
                                                <a href="/asset/portfolio-single-5-dark.html">Single 5</a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <a href="/asset/portfolio-parallax-dark.html">Parallax</a>
                                    </li>

                                    <li>
                                        <a href="/asset/portfolio-promo-dark.html">Promo</a>
                                    </li>

                                    <li>
                                        <a href="/asset/portfolio-lazyload-dark.html">Lazyload</a>
                                    </li>

                                </ul>


                            </li>



                            <li>
                                <a href="#" class="mn-has-sub">Blog <i class="mn-has-sub-icon"></i></a>


                                <ul class="mn-sub">

                                    <li>
                                        <a href="#" class="mn-has-sub">Classic <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/blog-classic-sidebar-left-dark.html">Sidebar Left</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-classic-sidebar-right-dark.html">Sidebar Right</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-classic-fullwidth-dark.html">Fullwidth</a>
                                            </li>
                                        </ul>

                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Columns <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/blog-columns-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-columns-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-columns-4col-dark.html">4 Columns</a>
                                            </li>
                                        </ul>

                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Masonry <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/blog-masonry-2col-dark.html">2 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-masonry-3col-dark.html">3 Columns</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-masonry-4col-dark.html">4 Columns</a>
                                            </li>
                                        </ul>

                                    </li>

                                    <li>
                                        <a href="#" class="mn-has-sub">Single <i class="mn-has-sub-icon-right right"></i></a>

                                        <ul class="mn-sub">
                                            <li>
                                                <a href="/asset/blog-single-sidebar-left-dark.html">Sidebar Left</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-single-sidebar-right-dark.html">Sidebar Right</a>
                                            </li>
                                            <li>
                                                <a href="/asset/blog-single-fullwidth-dark.html">Fullwidth</a>
                                            </li>
                                        </ul>

                                    </li>


                                </ul>


                            </li>



                            <li>
                                <a href="#" class="mn-has-sub">Shop <i class="mn-has-sub-icon"></i></a>


                                <ul class="mn-sub to-left">

                                    <li>
                                        <a href="/asset/shop-columns-2col-dark.html">2 Columns</a>
                                    </li>
                                    <li>
                                        <a href="/asset/shop-columns-3col-dark.html">3 Columns</a>
                                    </li>
                                    <li>
                                        <a href="/asset/shop-columns-4col-dark.html">4 Columns</a>
                                    </li>
                                    <li>
                                        <a href="/asset/shop-single-dark.html">Single Product</a>
                                    </li>
                                    <li>
                                        <a href="/asset/shop-cart-dark.html">Shopping Cart</a>
                                    </li>

                                </ul>


                            </li>



                            <li><a>&nbsp;</a></li>



                            <li>
                                <a href="#" class="mn-has-sub"><i class="main-nav-icon-search"></i> Search</a>

                                <ul class="mn-sub">

                                    <li>
                                        <div class="mn-wrap">
                                            <form method="post" class="form">
                                                <div class="search-wrap">
                                                    <input type="text" class="form-control search-field round" placeholder="Search..."/>
                                                    <button class="search-button animate" type="submit" title="Start Search">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </li>

                                </ul>

                            </li>



                            <li class="d-sm-none d-md-none d-lg-block">
                                <a href="/asset/shop-cart-dark.html"><i class="main-nav-icon-cart"></i> Cart</a>
                            </li>



                            <li>
                                <a href="#" class="mn-has-sub">Eng <i class="mn-has-sub-icon"></i></a>

                                <ul class="mn-sub">

                                    <li><a href="/asset/">English</a></li>
                                    <li><a href="/asset/">French</a></li>
                                    <li><a href="/asset/">German</a></li>

                                </ul>

                            </li> */}


                        </ul>
                    </div>


                </div>
            </nav>


            <main id="main">


                <section class="home-section bg-dark-alfa-70 bg-scroll light-content" data-background={page.videoThumbnail} id="home">
                    <div class="container min-height-100vh d-flex align-items-center pt-100 pb-100">


                        <div class="player" data-property={`{videoURL:'${page.videoUrl}',containment:'#home',autoPlay:true, showControls:false, showYTLogo: false, mute:true, startAt:0, opacity:1}`}>
                        </div>



                        <div class="home-content">
                            <h1 class="hs-line-3 mb-40 mb-xs-20 wow fadeInUpShort" data-wow-delay=".1s">High Precision German Engineering</h1>
                            <h2 class="hs-line-2 mb-70 mb-xs-40 wow fadeInUpShort" data-wow-delay=".2s">
                                <span class="text-rotate">
                                    The Right Tools For The Right Job,
                                    Grooming for below-the-waist,
                                    Are You Ready To Join The Movement?
                                </span>
                            </h2>
                            <div class="local-scroll mb-20 wow fadeInUpShort" data-wow-delay=".3s">
                                <a href={page.tokopediaUrl} target="__blank" class="btn btn-mod btn-w btn-large btn-round mx-md-1 mr-2">Tokopedia Official Store</a>
                                <a href={page.videoUrl} class="btn btn-mod btn-w btn-large btn-round mx-md-1 lightbox mfp-iframe">Play Reel</a>
                            </div>
                        </div>



                        <div class="local-scroll scroll-down-wrap wow fadeInUpShort" data-wow-offset="0">
                            <a href="#about" class="scroll-down"><i class="scroll-down-icon"></i><span class="sr-only">Scroll to the next section</span></a>
                        </div>


                    </div>
                </section>




                <section class="page-section bg-dark light-content" id="about">
                    <div class="container relative">

                        <div class="mb-120 mb-sm-50 mb-xs-20">
                            <div class="row section-text">

                                <div class="col-md-12 col-lg-4 mb-md-50 mb-xs-30">
                                    <div class="lead-alt wow linesAnimIn" data-splitting="lines">
                                      Misi kami adalah membuat Anda merasa feel good dan percaya diri.
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-4 mb-sm-50 mb-xs-30 wow linesAnimIn" data-splitting="lines">
                                Terlalu sering, kebersihan dasar "di bawah sana" diabaikan karena kurangnya informasi & tabu seputar perawatan di "bawah sana". Kami di sini untuk membantu Anda melawan stigma, dan memberikan solusi Anda dengan produk kelas presisi untuk barang-barang Anda yang paling berharga.
                                </div>

                                <div class="col-md-6 col-lg-4 mb-sm-50 mb-xs-30 wow linesAnimIn" data-splitting="lines">
                                  Dan, kami menunggu Anda untuk bergabung dengan kami. Ucapkan selamat tinggal kepada luka & goresan dan selamat datang kepada yang lebih segar dan bersih di "bawah sana".
                                </div>

                            </div>
                        </div>


                        <div class="count-wrapper">
                            <div class="row">


                                <div class="col-md-6 col-lg-3 mb-md-30">
                                    <div class="count-item">
                                        <div class="count-bg wow scalexIn"></div>
                                        <div class="relative wow fadeIn" data-wow-delay="1s">
                                            <div class="count-number">
                                                920
                                            </div>
                                            <div class="count-descr">
                                                <i class="fa fa-briefcase mr-2"></i>
                                                <span class="count-title">"Projects" Done</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div class="col-md-6 col-lg-3 mb-md-30">
                                    <div class="count-item">
                                        <div class="count-bg wow scalexIn"></div>
                                        <div class="relative wow fadeIn" data-wow-delay="1.1s">
                                            <div class="count-number">
                                                1050
                                            </div>
                                            <div class="count-descr">
                                                <i class="fa fa-heart"></i>
                                                <span class="count-title">Happy Customers</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div class="col-md-6 col-lg-3 mb-md-30">
                                    <div class="count-item">
                                        <div class="count-bg wow scalexIn"></div>
                                        <div class="relative wow fadeIn" data-wow-delay="1.2s">
                                            <div class="count-number">
                                                1000
                                            </div>
                                            <div class="count-descr">
                                                <i class="fa fa-coffee"></i>
                                                <span class="count-title">Confidence Boosts</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div class="col-md-6 col-lg-3 mb-md-30">
                                    <div class="count-item">
                                        <div class="count-bg wow scalexIn"></div>
                                        <div class="relative wow fadeIn" data-wow-delay="1.3s">
                                            <div class="count-number">
                                                98
                                            </div>
                                            <div class="count-descr">
                                                <i class="fa fa-lightbulb"></i>
                                                <span class="count-title">Great Ideas</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>


                    </div>
                </section>



                <hr class="mt-0 mb-0 white" />

                <section class="page-section bg-dark light-content">
                    <div class="container relative">

                        <div class="text-center mb-80 mb-sm-50">
                            <div class="row">
                                <div class="col-sm-6 offset-sm-3">
                                    <h2 class="section-title">Bestsellers</h2>
                                    <p class="section-title-descr">
                                        Our best selling products in this place.
                                    </p>
                                </div>
                                {/* <div class="col-sm-3 text-sm-end pt-30 pt-xs-0">
                                    <a href="/asset/shop-columns-3col-dark.html" class="section-more">Our Shop <i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                </div> */}
                            </div>
                        </div>

                        <div class="row">

                            {products.map(product => {
                              product = product.node.frontmatter
                              return (
                                <div class="col-sm-6 col-md-3 col-lg-3 mb-md-50">
                                    <div class="post-prev-img">
                                        <a href={product.tokpedUrl} tabindex="-1"><img src={product.thumbnail} alt="" class="wow scaleOutIn" data-wow-duration="1.2s" /></a>
                                        <div class="intro-label">
                                            <span class="badge badge-danger bg-red">Sale</span>
                                        </div>
                                    </div>
                                    <div class="post-prev-title text-center mb-10">
                                        <a href={product.tokpedUrl}>{product.name}</a>
                                    </div>
                                    <div class="post-prev-text text-center">
                                        <del>
                                        {new Intl.NumberFormat('id', {
                                          style: 'currency',
                                          currency: 'IDR',
                                          maximumFractionDigits: 0
                                        }).format(product.price)}
                                        </del>
                                        &nbsp;<strong>{new Intl.NumberFormat('id', {
                                          style: 'currency',
                                          currency: 'IDR',
                                          maximumFractionDigits: 0
                                        }).format(product.discountedPrice)}</strong>
                                    </div>
                                    <div class="post-prev-more text-center">
                                        <a href={product.tokpedUrl} class="btn btn-mod btn-w btn-round"><i class="fa fa-shopping-cart"></i> Add to cart</a>
                                    </div>
                                </div>
                              )
                            })}

                        </div>

                    </div>
                </section>


                <section class="page-section bg-dark light-content" id="services">
                    <div class="container relative">

                        <div class="text-center mb-80 mb-sm-50">
                            <h2 class="section-title">Why HUX</h2>
                            <p class="section-title-descr">
                            Kami brand trimmer alat kelamin berkualitas tinggi pertama dan terkemuka yang diperkenalkan di Indonesia. Our products speak for itself.
                            </p>
                        </div>


                        <div class="row services-grid">


                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <div class="services-item text-center wow fadeIn" data-wow-delay="0" data-wow-duration="1.5s">
                                    <div class="services-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M24 7.192c0 4.661-5.57 9.427-12 15.808-.851-.844-1.677-1.65-2.486-2.44l1.415-1.415 1.071 1.047c5.256-5.149 10-9.558 10-13 0-2.873-2.216-4.182-4.274-4.182-3.257 0-4.976 3.475-5.726 5.021-.747-1.54-2.484-5.03-5.72-5.031-2.315-.001-4.28 1.516-4.28 4.192 0 1.398.794 2.96 2.077 4.663l-1.431 1.431c-1.639-2.126-2.646-4.12-2.646-6.094 0-4.005 3.098-6.192 6.281-6.192 2.197 0 4.434 1.042 5.719 3.248 1.279-2.195 3.521-3.238 5.726-3.238 3.177 0 6.274 2.171 6.274 6.182zm-10.539 7.301l-7.968 7.965c-.339.341-.822.542-1.388.541-.802 0-1.772-.402-2.746-1.376-.959-.958-1.358-1.922-1.358-2.721 0-.565.201-1.051.543-1.392l7.967-7.968c.342-.342.826-.543 1.392-.543.8.001 1.764.398 2.724 1.358.973.973 1.376 1.943 1.374 2.746 0 .565-.198 1.047-.54 1.39zm-1.715-1.587c-.229.228-.229.597 0 .825.228.227.597.228.824 0 .228-.229.228-.598 0-.825-.228-.228-.596-.227-.824 0zm-1.238 1.238c-.227.227-.229.596 0 .825.228.228.598.227.825 0 .229-.228.229-.598 0-.825-.229-.228-.597-.228-.825 0zm0-2.476c-.227.229-.228.598-.001.826.229.228.598.228.826-.001.227-.227.229-.596-.001-.824-.227-.228-.596-.228-.824-.001zm-1.237 1.238c-.228.228-.229.598-.002.825.229.229.599.227.826 0 .227-.228.228-.596-.001-.825-.226-.227-.595-.227-.823 0zm0-2.475c-.228.228-.229.598 0 .825.226.228.598.228.824 0 .228-.227.227-.597 0-.824-.227-.228-.596-.228-.824-.001zm-1.237 1.237c-.228.228-.229.598-.001.826.227.227.599.227.826 0 .227-.228.226-.597 0-.825-.228-.228-.598-.228-.825-.001zm-5.776 7.425c.228-.228.228-.597 0-.825-.229-.228-.598-.228-.825 0-.229.228-.229.597 0 .825.228.227.596.228.825 0zm1.237-1.237c.228-.228.228-.598 0-.826-.229-.228-.598-.228-.825 0s-.228.597 0 .825c.227.228.597.228.825.001zm0 2.475c.228-.228.228-.598 0-.825-.227-.228-.598-.229-.825 0-.228.227-.227.598.001.824.226.228.596.229.824.001zm1.237-1.237c.228-.228.228-.598 0-.826-.227-.227-.598-.228-.825 0-.228.228-.227.598 0 .825.228.227.598.228.825.001zm0 2.475c.228-.229.228-.598 0-.826s-.598-.228-.825 0c-.228.228-.228.597 0 .824.228.229.598.229.825.002zm1.24-1.239c.226-.226.226-.596-.002-.824-.228-.228-.597-.228-.825 0-.228.228-.228.597 0 .825.228.228.597.228.827-.001zm4.189-4.188l-3.301-3.299-3.017 3.016 3.302 3.299 3.016-3.016z"/></svg>
                                    </div>
                                    <h3 class="services-title">SkinSafe™ Technology</h3>
                                    <div class="services-descr">
                                    Ceramic Blade yang dapat diganti yang menampilkan teknologi SkinSafe™ dipasang kembali dari tepi 3mm dan dirancang dengan presisi untuk kepercayaan maksimal saat memangkas di bawah pinggang.
                                    </div>
                                    {/* <div class="services-more">
                                        <a href="#" class="text-link">Learn More</a>
                                    </div> */}
                                </div>
                            </div>



                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <div class="services-item text-center wow fadeIn" data-wow-delay=".1s" data-wow-duration="1.5s">
                                    <div class="services-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 16c2.947 0 5.333-2.365 5.333-5.284 0-2.917-2.087-5.918-5.333-10.716-3.246 4.798-5.332 7.799-5.332 10.716 0 2.919 2.385 5.284 5.332 5.284zm-.018-12.587c.311.484.685 1.325.685 2.213 0 2.606-2.667 3.033-2.667 1.447 0-1.088 1.326-2.696 1.982-3.66zm.018 16.587c-2.367 0-5.711-.614-7.285-2.356.473-.294 1.15-.61 2.021-.889.923.589 2.702 1.245 5.264 1.245s4.341-.656 5.265-1.245c.87.278 1.548.595 2.022.889-1.574 1.742-4.92 2.356-7.287 2.356zm11.997-2c0 3.313-5.37 6-11.997 6-6.625 0-11.997-2.687-11.997-6l.003-.126c.043-1.009.615-1.921 1.505-2.398s1.965-.448 2.829.074l.023.014c-1.513.763-2.361 1.678-2.361 2.436 0 1.631 3.895 4 9.998 4s9.998-2.369 9.998-4c0-.757-.847-1.671-2.358-2.436l.021-.012c.877-.529 1.969-.548 2.864-.052s1.458 1.434 1.472 2.458v.042zm-4.999-4.031c1.453-1.406 3.064-.182 4.402-1.477.418-.403.603-.902.603-1.384 0-1.279-1.481-2.261-3.021-1.436-1.234.661-1.921 2.349-1.984 4.297zm.178-5.067c.63-1.037 1.749-.57 2.329-1.524.688-1.133-.729-2.29-1.829-1.269-.615.57-.76 1.654-.5 2.793zm-16.153.77c-1.539-.825-3.021.157-3.021 1.436 0 .482.185.98.602 1.384 1.338 1.295 2.95.071 4.402 1.477-.062-1.948-.748-3.636-1.983-4.297zm1.307-3.563c-1.1-1.021-2.518.136-1.83 1.269.58.954 1.699.487 2.33 1.524.259-1.139.115-2.223-.5-2.793z"/></svg>
                                    </div>
                                    <h3 class="services-title">IPX7 Waterproof</h3>
                                    <div class="services-descr">
                                    Memangkas di kamar mandi itu mudah dan dapat mengurangi keberantakan. Mengoperasikan trimmer kami dengan nyaman dalam kondisi basah atau kering.
Dijamin aman untuk dipakai sambil mandi di showermu.
                                    </div>
                                    {/* <div class="services-more">
                                        <a href="#" class="text-link">Learn More</a>
                                    </div> */}
                                </div>
                            </div>



                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <div class="services-item text-center wow fadeIn" data-wow-delay=".2s" data-wow-duration="1.5s">
                                    <div class="services-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M23.948.042c-.413-.028-.817-.042-1.214-.042-8.6 0-13.497 6.557-15.278 11.833l4.727 4.727c5.428-1.944 11.817-6.66 11.817-15.168 0-.44-.017-.89-.052-1.35zm-11.277 14.178l-2.883-2.883c1.221-2.859 4.691-8.945 12.199-9.32-.251 5.775-4.041 9.932-9.316 12.203zm5.471 1.538c-.547.373-1.09.71-1.628 1.011-.187.891-.662 1.842-1.351 2.652-.002-.576-.162-1.156-.443-1.738-.495.225-.966.418-1.414.588.66 1.709-.012 2.971-.915 4.154 1.296-.098 2.656-.732 3.728-1.805 1.155-1.155 1.967-2.823 2.023-4.862zm-11.82-6.469c-.579-.28-1.158-.438-1.732-.441.803-.681 1.744-1.153 2.626-1.345.314-.552.667-1.097 1.039-1.633-2.039.055-3.708.867-4.864 2.023-1.071 1.071-1.706 2.433-1.804 3.728 1.184-.904 2.446-1.576 4.155-.914.173-.471.366-.944.58-1.418zm7.738.663c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0c.391.392.391 1.024 0 1.415s-1.024.39-1.414-.001zm4.949-4.951c-.78-.78-2.047-.78-2.828 0-.781.781-.781 2.049 0 2.829.781.781 2.048.781 2.829 0 .78-.78.78-2.047-.001-2.829zm-1.908 1.911c-.273-.273-.273-.718 0-.99.271-.273.717-.273.99 0 .272.272.271.717 0 .99-.274.272-.718.272-.99 0zm-6.747 10.65c-1.492 3.81-5.803 6.208-10.354 6.438.219-4.289 2.657-8.676 6.64-10.153l.805.806c-4.331 2.755-4.653 5.346-4.665 6.575 1.268-.015 4.054-.344 6.778-4.464l.796.798z"/></svg>
                                    </div>
                                    <h3 class="services-title">7200 RPM Motor</h3>
                                    <div class="services-descr">
                                      Motor premium 7200 RPM dengan teknologi QuietStroke™ dan baterai Li-ion yang dapat diisi ulang dengan charging dock
                                    </div>
                                    {/* <div class="services-more">
                                        <a href="#" class="text-link">Learn More</a>
                                    </div> */}
                                </div>
                            </div>



                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <div class="services-item text-center wow fadeIn" data-wow-delay=".0s" data-wow-duration="1.5s">
                                    <div class="services-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"/></svg>
                                    </div>
                                    <h3 class="services-title">Charging Dock</h3>
                                    <div class="services-descr">
                                      Charging dock yang nyaman mengisi daya trimmer mentransfer energi dari dok ke mesin dengan gampang, mudah, nyaman, indah dilihat.
                                    </div>
                                    {/* <div class="services-more">
                                        <a href="#" class="text-link">Learn More</a>
                                    </div> */}
                                </div>
                            </div>



                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <div class="services-item text-center wow fadeIn" data-wow-delay=".1s" data-wow-duration="1.5s">
                                    <div class="services-icon" style={{marginBottom: "32px"}}>
                                    <i class="fab fa-edge" aria-hidden="true"></i>
                                    </div>
                                    <h3 class="services-title">Anti-Slip Grip</h3>
                                    <div class="services-descr">
                                    Grip ergonomis dengan Teknologi AntiSlip™ kami yang terbuat dari bahan berkualitas tinggi untuk tingkat presisi trimming yang tinggi dalam segala kondisi.
                                    </div>
                                    {/* <div class="services-more">
                                        <a href="#" class="text-link">Learn More</a>
                                    </div> */}
                                </div>
                            </div>



                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <div class="services-item text-center wow fadeIn" data-wow-delay=".2s" data-wow-duration="1.5s">
                                    <div class="services-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M15.463 14.861c-.241.705-.242.569 0 1.277l.037.223c0 .225-.111.441-.308.578-.628.435-.545.325-.781 1.033-.099.295-.385.495-.708.495h-.001c-.774-.003-.64-.044-1.265.395-.129.092-.283.138-.437.138s-.308-.046-.438-.138c-.625-.439-.49-.397-1.265-.395h-.002c-.322 0-.608-.2-.706-.495-.236-.709-.156-.599-.781-1.033-.197-.136-.308-.354-.308-.578l.037-.222c.242-.705.242-.569 0-1.277l-.037-.223c0-.225.111-.441.309-.578.625-.434.544-.324.781-1.033.098-.296.384-.495.706-.495h.002c.772.002.636.047 1.265-.395.129-.092.283-.138.437-.138s.308.046.438.137c.625.439.49.397 1.265.395h.001c.323 0 .609.199.708.495.236.708.153.598.781 1.033.196.137.308.354.308.578l-.038.223zm-1.713.639c0-.966-.783-1.75-1.75-1.75s-1.75.784-1.75 1.75.783 1.75 1.75 1.75 1.75-.784 1.75-1.75zm-3.067 3.966c-.383 0-.686-.037-.937-.107-.154 1.534-.68 2.685-1.746 3.796.428.053.975-.047 1.416-.28.159.318.326.715.384 1.125 1.005-1.149 1.633-2.527 1.867-4.035-.472-.091-.617-.248-.984-.499zm2.634 0c-.368.253-.521.41-.983.499.234 1.508.862 2.886 1.866 4.036.058-.41.225-.807.384-1.125.441.232.988.333 1.416.28-1.064-1.109-1.584-2.266-1.739-3.797-.252.069-.556.107-.944.107zm-11.317-19.466v21h5.154c.337-.535.528-1.104.602-1.841l.015-.159h-3.771v-17h16v17h-3.765l.016.156c.075.742.265 1.312.598 1.844h5.151v-21h-20zm16 5h-12v1h12v-1zm0 2h-12v1h12v-1zm0 2h-12v1h12v-1z"/></svg>
                                    </div>
                                    <h3 class="services-title">ISO, FC, CE Certified</h3>
                                    <div class="services-descr">
                                      Pabrik dan lini produksi kami telah bersertifikat ISO, FC, CE dan RoHS. Agar Anda tahu bahwa produk Anda dijamin telah melewati standar produksi dan jaminan kualitas tertinggi.
                                    </div>
                                    {/* <div class="services-more">
                                        <a href="#" class="text-link">Learn More</a>
                                    </div> */}
                                </div>
                            </div>


                        </div>


                    </div>
                </section>




                <section class="page-section pt-0 pb-0 banner-section bg-dark-lighter light-content">
                    <div class="container relative">

                        <div class="row">

                            <div class="col-lg-6 relative">
                                <div class="banner-image-1">
                                    <img src={page.hWImage1} alt="" class="wow scaleOutIn" data-wow-duration="1.2s" data-wow-offset="292" />
                                </div>
                                <div class="banner-image-2">
                                    <img src={page.hWImage2} alt="" class="wow scaleOutIn" data-wow-duration="1.2s" data-wow-offset="70" />
                                </div>
                            </div>

                            <div class="col-lg-5 offset-lg-1">
                                <div class="mt-140 mt-lg-80 mt-md-60 mt-xs-30 mb-140 mb-lg-80">
                                    <div class="banner-content wow fadeInUpShort" data-wow-duration="1.2s">
                                        <h3 class="banner-heading">IPX7 Waterproof Certified</h3>
                                        <div class="banner-decription">
                                            Produk trimmer kami sudah tersertifikasi waterproof, jadi anda tidak perlu khawatir lagi untuk memangkas bulu anda sambil mandi. Idealnya dengan air hangat supaya kulitmu bisa ditarik lurus, untuk memaksimalkan pemangkasan dan keamanan.
                                        </div>
                                        {/* <div class="local-scroll">
                                            <a href="/asset/pages-services-1-dark.html" class="btn btn-mod btn-w btn-large btn-round">View Services</a>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>




                <section class="page-section pb-0 bg-dark light-content" id="portfolio">
                    <div class="full-wrapper relative">

                        <div class="text-center mb-80 mb-sm-50">
                            <h2 class="section-title">Gallery</h2>
                            <p class="section-title-descr">
                                A Closer Look
                            </p>
                        </div>


                        <div class="works-filter text-center" role="tablist">
                            <a href="#" class="filter active" role="tab" aria-selected="true" data-filter="*">All works</a>
                            <a href="#branding" class="filter" role="tab" aria-selected="false" data-filter=".branding">Product</a>
                            <a href="#design" class="filter" role="tab" aria-selected="false" data-filter=".design">Features</a>
                            <a href="#photography" class="filter" role="tab" aria-selected="false" data-filter=".photography">People</a>
                        </div>



                        <ul class="works-grid work-grid-3 work-grid-gut clearfix hide-titles" id="work-grid">
                          <>
                            {page.productGallery.map(photo => {
                              return (
                                <li class="work-item mix branding">
                                    <a href={photo.image} class="work-lightbox-link mfp-image">
                                        <div class="work-img">
                                            <div class="work-img-bg wow-p scalexIn"></div>
                                            <img src={photo.image} alt="Work Description" class="wow-p fadeIn" data-wow-delay="1s" />
                                        </div>
                                        <div class="work-intro">
                                            <h3 class="work-title">{photo.label}</h3>
                                            <div class="work-descr">
                                                {photo.desc}
                                            </div>
                                        </div>
                                    </a>
                                </li>
                              )
                            })}

                            {page.featuresGallery.map(photo => {
                              return (
                                <li class="work-item mix design">
                                    <a href={photo.image} class="work-lightbox-link mfp-image">
                                        <div class="work-img">
                                            <div class="work-img-bg wow-p scalexIn"></div>
                                            <img src={photo.image} alt="Work Description" class="wow-p fadeIn" data-wow-delay="1s" />
                                        </div>
                                        <div class="work-intro">
                                            <h3 class="work-title">{photo.label}</h3>
                                            <div class="work-descr">
                                                {photo.desc}
                                            </div>
                                        </div>
                                    </a>
                                </li>
                              )
                            })}
                            {page.peopleGallery.map(photo => {
                              return (
                                <li class="work-item mix photography">
                                    <a href={photo.image} class="work-lightbox-link mfp-image">
                                        <div class="work-img">
                                            <div class="work-img-bg wow-p scalexIn"></div>
                                            <img src={photo.image} alt="Work Description" class="wow-p fadeIn" data-wow-delay="1s" />
                                        </div>
                                        <div class="work-intro">
                                            <h3 class="work-title">{photo.label}</h3>
                                            <div class="work-descr">
                                                {photo.desc}
                                            </div>
                                        </div>
                                    </a>
                                </li>
                              )
                            })}
</>
                            {/* <li class="work-item mix design">
                                <a href="/asset/portfolio-single-1-dark.html" class="work-ext-link">
                                    <div class="work-img">
                                        <div class="work-img-bg wow-p scalexIn"></div>
                                        <img src="/asset/images/portfolio/projects-5.jpg" alt="Work Description" class="wow-p fadeIn" data-wow-delay="1s" />
                                    </div>
                                    <div class="work-intro">
                                        <h3 class="work-title">White Table</h3>
                                        <div class="work-descr">
                                            External Page
                                        </div>
                                    </div>
                                </a>
                            </li> */}


                        </ul>



                        <section class="small-section bg-dark-lighter light-content">
                            <div class="container relative">
                                <div class="row wow fadeInUpShort">
                                    <div class="col-lg-5 offset-lg-2">
                                        <h3 class="call-action-1-heading">Want to know more about us?</h3>
                                        <div class="call-action-1-decription mb-0 pb-md-20">
                                        Kami bertujuan untuk memberikan Anda teknologi terbaik dan terdepan yang sains dapat berikan
                                        </div>
                                    </div>
                                    <div class="col-lg-3 pt-10 text-lg-end">
                                        <div class="local-scroll">
                                            <a href="/about" class="btn btn-mod btn-w btn-large btn-round">About Us</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </section>




                {/* <section class="page-section bg-dark light-content">
                    <div class="container relative">


                        <div class="row">


                            <div class="col-md-12 col-lg-3">
                                <div class="align-left">
                                    <h2 class="work-process-heading mt-0">Work Process</h2>
                                    <p class="work-process-description">
                                        Lorem ipsum dolor sit amet casume adipisin elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.
                                    </p>
                                </div>
                            </div>



                            <div class="col-md-4 col-lg-3">
                                <div class="work-process-item text-center pt-20">
                                    <div class="work-process-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                                            <path d="M20 15c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1m-3 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1m-3 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1m5.415 4.946c-1 .256-1.989.482-3.324.482-3.465 0-7.091-2.065-7.091-5.423 0-3.128 3.14-5.672 7-5.672 3.844 0 7 2.542 7 5.672 0 1.591-.646 2.527-1.481 3.527l.839 2.686-2.943-1.272zm-13.373-3.375l-4.389 1.896 1.256-4.012c-1.121-1.341-1.909-2.665-1.909-4.699 0-4.277 4.262-7.756 9.5-7.756 5.018 0 9.128 3.194 9.467 7.222-1.19-.566-2.551-.889-3.967-.889-4.199 0-8 2.797-8 6.672 0 .712.147 1.4.411 2.049-.953-.126-1.546-.272-2.369-.483m17.958-1.566c0-2.172-1.199-4.015-3.002-5.21l.002-.039c0-5.086-4.988-8.756-10.5-8.756-5.546 0-10.5 3.698-10.5 8.756 0 1.794.646 3.556 1.791 4.922l-1.744 5.572 6.078-2.625c.982.253 1.932.407 2.85.489 1.317 1.953 3.876 3.314 7.116 3.314 1.019 0 2.105-.135 3.242-.428l4.631 2-1.328-4.245c.871-1.042 1.364-2.384 1.364-3.75"/>
                                        </svg>
                                    </div><h3 class="work-process-title">1. Disscuss</h3>
                                </div>
                            </div>



                            <div class="col-md-4 col-lg-3">
                                <div class="work-process-item text-center pt-20">
                                    <div class="work-process-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                                            <path d="M6 3.447h-1v-1.447h19v16h-7.731l2.731 4h-1.311l-2.736-4h-1.953l-2.736 4h-1.264l2.732-4h-2.732v-1h8v-1h3v1h3v-14h-17v.447zm2.242 17.343c-.025.679-.576 1.21-1.256 1.21-.64 0-1.179-.497-1.254-1.156l-.406-4.034-.317 4.019c-.051.656-.604 1.171-1.257 1.171-.681 0-1.235-.531-1.262-1.21l-.262-6.456-.308.555c-.241.437-.8.638-1.265.459-.404-.156-.655-.538-.655-.951 0-.093.012-.188.039-.283l1.134-4.098c.17-.601.725-1.021 1.351-1.021h4.096c.511 0 1.012-.178 1.285-.33.723-.403 2.439-1.369 3.136-1.793.394-.243.949-.147 1.24.217.32.396.286.95-.074 1.297l-3.048 2.906c-.375.359-.595.849-.617 1.381-.061 1.397-.3 8.117-.3 8.117zm-5.718-10.795c-.18 0-.34.121-.389.294-.295 1.04-1.011 3.666-1.134 4.098l1.511-2.593c.172-.295.623-.18.636.158l.341 8.797c.01.278.5.287.523.002 0 0 .269-3.35.308-3.944.041-.599.449-1.017.992-1.017.547.002.968.415 1.029 1.004.036.349.327 3.419.385 3.938.043.378.505.326.517.022 0 0 .239-6.725.3-8.124.033-.791.362-1.523.925-2.061l3.045-2.904c-.661.492-2.393 1.468-3.121 1.873-.396.221-1.07.457-1.772.457h-4.096zm16.476 1.005h-5v-1h5v1zm2-2h-7v-1h7v1zm-15.727-4.994c-1.278 0-2.315 1.038-2.315 2.316 0 1.278 1.037 2.316 2.315 2.316s2.316-1.038 2.316-2.316c0-1.278-1.038-2.316-2.316-2.316zm0 1c.726 0 1.316.59 1.316 1.316 0 .726-.59 1.316-1.316 1.316-.725 0-1.315-.59-1.315-1.316 0-.726.59-1.316 1.315-1.316zm15.727 1.994h-7v-1h7v1z"/>
                                        </svg>
                                    </div><h3 class="work-process-title">2. Make</h3>
                                </div>
                            </div>



                            <div class="col-md-4 col-lg-3">
                                <div class="work-process-item text-center pt-20">
                                    <div class="work-process-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                                            <path d="M15.551 14.703c.474 1.372 2.049 2.459 3.801 1.868l.021-.007c1.565-.544 2.391-2.242 1.854-3.807-.187-.546-.425-1.137-.695-1.757h-5.967c.299 1.366.625 2.647.986 3.703m2.264-9.232l-4.051 1.388c.183 1.037.379 2.103.59 3.141h5.726c-.655-1.404-1.445-2.94-2.265-4.529m.492-1.226c1.524 2.958 3.086 5.915 3.866 8.187.598 1.744-.045 3.895-2.028 4.874l1.211 3.529c.291.812 1.322.926 2.392.808l.252.735-4.728 1.622-.272-.788c.903-.479 1.688-1.215 1.41-2.054l-1.208-3.52c-2.162.439-3.994-.861-4.596-2.61-.791-2.304-1.405-5.566-1.976-8.837l5.677-1.946zm-8.872 6.755h-5.967c-.27.62-.508 1.211-.695 1.757-.536 1.565.289 3.263 1.854 3.807l.021.007c1.753.591 3.328-.496 3.801-1.868.362-1.056.688-2.337.986-3.703m-5.515-1h5.726c.211-1.038.407-2.104.591-3.141l-4.051-1.388c-.821 1.589-1.611 3.125-2.266 4.529m7.45-3.809c-.571 3.271-1.185 6.533-1.976 8.837-.602 1.749-2.434 3.049-4.596 2.61l-1.208 3.52c-.278.839.507 1.575 1.41 2.054l-.271.788-4.729-1.622.252-.735c1.07.118 2.102.004 2.392-.808l1.211-3.529c-1.983-.979-2.625-3.13-2.028-4.874.78-2.272 2.342-5.229 3.867-8.187l5.676 1.946zm7.13 7.811c.414 0 .75.336.75.75 0 .413-.336.75-.75.75s-.75-.337-.75-.75c0-.414.336-.75.75-.75m-14.5.248c0 .414.336.75.75.75s.75-.336.75-.75c0-.413-.336-.75-.75-.75s-.75.337-.75.75m3.25-2.25c.414 0 .75.337.75.75 0 .414-.336.75-.75.75s-.75-.336-.75-.75c0-.413.336-.75.75-.75m10.5-.499c.414 0 .75.336.75.751 0 .413-.336.75-.75.75s-.75-.337-.75-.75c0-.415.336-.751.75-.751m-5.249-7.977v-3.023c0-.277-.223-.5-.5-.5-.275 0-.499.223-.499.5v3.023c0 .276.224.5.499.5.277 0 .5-.224.5-.5m1.932.462l1.641-2.79c.142-.238.062-.545-.176-.685-.239-.139-.544-.062-.684.177l-1.643 2.79c-.14.238-.06.545.176.685.08.047.167.069.254.069.172 0 .339-.088.432-.246m-4.552.246c-.171 0-.337-.088-.432-.246l-1.642-2.79c-.14-.238-.061-.545.177-.685.237-.14.544-.061.685.177l1.643 2.79c.139.238.061.545-.178.685-.08.047-.166.069-.253.069"/>
                                        </svg>
                                    </div><h3 class="work-process-title">3. Product</h3>
                                </div>
                            </div>


                       </div>


                    </div>
                </section> */}




                {/* <hr class="mt-0 mb-0 white"/> */}




                {/* <section class="page-section bg-dark light-content">
                    <div class="container relative">
                        <div class="row">


                            <div class="col-lg-7 mb-md-60 mb-xs-30">
                                <div class="call-action-2-images">

                                    <div class="call-action-2-image-1">
                                        <img src="/asset/images/promo-3.jpg" alt="" class="wow scaleOutIn" data-wow-duration="1.2s" data-wow-offset="255" />
                                    </div>

                                    <div class="call-action-2-image-2">
                                        <img src="/asset/images/promo-4.jpg" alt="" class="wow scaleOutIn" data-wow-duration="1.2s" data-wow-offset="134" />
                                    </div>

                                    <div class="call-action-2-image-3">
                                        <img src="/asset/images/promo-5.jpg" alt="" class="wow scaleOutIn" data-wow-duration="1.2s" data-wow-offset="0" />
                                    </div>

                                </div>
                            </div>



                            <div class="col-lg-5 wow fadeInUpShort" data-wow-duration="1.2s" data-wow-offset="255">

                                <h2 class="section-title mb-50 mb-sm-20">Why choose us?</h2>

                                <dl class="call-action-2-text mb-60 mb-sm-30">
                                    <dt>
                                        01. We are strongly creative.
                                    </dt>
                                    <dd>
                                        Lorem ipsum dolor sit amet, rembe adipiscing elite. Inwege maximus ligula semper metusere pellentesque mattis.
                                    </dd>
                                    <dt>
                                        02. We are very responsible.
                                    </dt>
                                    <dd>
                                        Fusce aliquet quam eget neque ultrices elementum. Nulla posuere felis id arcu blandit sagittis. Eleifender vestibulum purus risus.
                                    </dd>
                                    <dt>
                                        03. We are super friendly.
                                    </dt>
                                    <dd>
                                        Integer non dapibus diam, ac eleifend lectus. Praesent sed nisi eleifend, fermentum orci sit amet, iaculis libero interdum.
                                    </dd>
                                </dl>

                                <div class="local-scroll">
                                    <a href="/asset/pages-contact-1-dark.html" class="btn btn-mod btn-w btn-large btn-round">Start Project</a>
                                </div>

                            </div>


                        </div>
                    </div>
                </section> */}




                <hr class="mt-0 mb-0 white"/>



                <div class="fullwidth-slider owl-carousel bg-dark-lighter light-content" id="tutorial">

                  <section class="page-section bg-dark-lighter light-content">
                      <div class="container relative">

                          <div class="row">

                              <div class="col-md-7 mb-sm-40">


                                  <div class="work-full-media mt-0">
                                      <img src={page.tutorialMainImage} alt="" />
                                  </div>


                              </div>

                              <div class="col-md-5 col-lg-4 offset-lg-1 d-flex align-items-center">


                                  <div class="text">
                                      <h2 class="mb-30 mb-xxs-10">How To Tutorial</h2>
                                      <p>
                                          Geser ke kanan untuk mengikuti langkah-langkah petunjuk penggunaan mesin cukur kami supaya anda dijamin mendapatkan pengalaman yang <strong>aman</strong>, stress-free, dan sukses.
                                      </p>

                                      {/* <div class="mt-40">
                                          <a href="#" class="btn btn-mod btn-w btn-border btn-round btn-medium" target="_blank">View online</a>
                                      </div> */}

                                  </div>


                              </div>

                          </div>

                      </div>
                  </section>
                  {page.tutorial.map(step => {
                    return (
                      <section class="page-section bg-dark-lighter light-content">
                          <div class="container relative">

                              <div class="row">

                                  <div class="col-md-5 col-lg-4 mb-sm-40 d-flex align-items-center">


                                      <div class="text">
                                          <h2 class="mb-30 mb-xxs-10">{step.title}</h2>
                                          <p>
                                            {step.desc}
                                          </p>

                                      </div>


                                  </div>

                                  <div class="col-md-7 offset-lg-1">


                                      {/* <div class="work-full-media mt-0">

                                          <iframe src="http://player.vimeo.com/video/37066208?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff" width="1000" height="563" allowfullscreen></iframe>

                                      </div> */}
                                      <div class="video">
                                        <video preload="auto" loop="" controls="controls" poster={step.thumbnail}>
                                          <source src={step.video} type="video/mp4"/>
                                          {/* <source src="/asset/video/video.webm" type="video/webm"/> */}
                                        </video>
                                      </div>


                                  </div>

                            </div>

                          </div>
                      </section>
                    )
                  })}

                </div>


                <section class="page-section bg-dark light-content">
                    <div class="container relative">
                        <div class="row">


                            <div class="col-lg-6 wow fadeInUpShort" data-wow-duration="1.2s" data-wow-offset="205">

                                <div class="row">
                                    <div class="col-lg-10">
                                        <h2 class="section-title mb-60 mb-sm-30">Teknologi Terdepan <br/>Customer Service #1</h2>
                                    </div>
                                </div>


                                <div class="row alt-features-grid">


                                    <div class="col-lg-6">
                                        <div class="alt-features-item">
                                            <div class="alt-features-icon">
                                              <i class="fas fa-certificate" aria-hidden="true"></i>
                                            </div>
                                            <h3 class="alt-features-title">6 month warranty*</h3>
                                            <div class="alt-features-descr">
                                                Anda <strong>dijamin berhak mendapatkan produk pengganti baru</strong> jika produk yang anda beli dinilai rusak dengan penggunaan standar dalam masa garansi. Info selengkapnya di halaman produk.
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-lg-6">
                                        <div class="alt-features-item">
                                            <div class="alt-features-icon">
                                            <i class="fas fa-globe-americas" aria-hidden="true"></i>
                                            </div>
                                            <h3 class="alt-features-title">World-Class Technology</h3>
                                            <div class="alt-features-descr">
                                                Bentuk ergonomis dan pemilihan material dari designer di Italy. Teknologi Motor dan Ceramic Blade yang menggunakan ahli-ahli teknisi dari Jerman.
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-lg-6">
                                        <div class="alt-features-item">
                                            <div class="alt-features-icon">
                                            <i class="fas fa-hand-holding-heart" aria-hidden="true"></i>
                                            </div>
                                            <h3 class="alt-features-title">Always Here For You</h3>
                                            <div class="alt-features-descr">
                                                Kami selalu hadir dan siap untuk menjawab semua pertanyaan anda.
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-lg-6">
                                        <div class="alt-features-item">
                                            <div class="alt-features-icon">
                                            <i class="fas fa-truck" aria-hidden="true"></i>
                                            </div>
                                            <h3 class="alt-features-title">Free Shipping & Cashback</h3>
                                            <div class="alt-features-descr">
                                                Dapatkan produkmu langsung ke rumah tanpa perlu memikir panjang tentang biaya pengiriman. Info selengkapnya di halaman produk.
                                            </div>
                                        </div>
                                    </div>


                                </div>


                            </div>



                            <div class="col-lg-6">
                                <div class="call-action-3-images mt-xs-0 text-end">

                                    <div class="call-action-3-image-1">
                                        <img src={page.ttcsImage2} alt="" class="wow scaleOutIn" data-wow-duration="1.2s" data-wow-offset="205" />
                                    </div>

                                    <div class="call-action-3-image-2-wrap d-flex align-items-center">
                                        <div class="call-action-3-image-2">
                                            <img src={page.ttcsImage1} alt="" class="wow scaleOutIn" data-wow-duration="1.2s" />
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>
                </section>




                <section class="page-section bg-dark bg-dark-alfa-70 bg-scroll light-content" data-background="/asset/images/hux_bg0.jpeg">
                    <div class="container relative">

                    <div class="row">
                        <div class=" col-lg-8 offset-lg-2 wow fadeInUpShort">

                            <div class="text-center mb-50 mb-sm-20">
                                <h2 class="section-title">Apa Yang Dikatakan Customer Kami?</h2>
                            </div>

                            <div class="text-slider">

                                {page.testimonials.map(testimony => {
                                  return (
                                    <div>
                                        <blockquote class="testimonial">
                                            <p>
                                            {testimony.text}
                                            </p>
                                            <footer class="testimonial-author mt-50 mt-sm-20">
                                                — {testimony.name}
                                            </footer>
                                        </blockquote>
                                    </div>
                                  )
                                })}


                            </div>

                        </div>
                    </div>

                    </div>
                </section>

                <section class="page-section bg-dark light-content" id="blog">
                    <div class="container relative">

                        <div class="text-center mb-80 mb-sm-50">
                            <div class="row">
                                <div class="col-sm-6 offset-sm-3">
                                    <h2 class="section-title">Our Blog</h2>
                                    <p class="section-title-descr">
                                        The latest news in our blog
                                    </p>
                                </div>
                                {/* <div class="col-sm-3 text-sm-end pt-30 pt-xs-0">
                                    <a href="/asset/blog-classic-sidebar-right-dark.html" class="section-more">Our Blog <i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                </div> */}
                            </div>
                        </div>

                        <div class="row">
                            {blogs.map(blog => {
                              let blogUrl = blog.node.fields.slug;
                              let data = blog.node.frontmatter;
                              return (
                                <div class="col-sm-6 col-md-4 col-lg-4 mb-md-50 mt-5">

                                <div class="post-prev-img">
                                    <a href={blogUrl} tabindex="-1"><img src={data.mainImage} alt="" class="wow scaleOutIn" data-wow-duration="1.2s" /></a>
                                </div>

                                <h3 class="post-prev-title">
                                    <a href={blogUrl}>{data.title}</a>
                                </h3>

                                <div class="post-prev-info">
                                    {data.date}
                                </div>

                                <div class="post-prev-text">
                                    {data.intro}
                                </div>

                                <div class="post-prev-more">
                                    <a href={blogUrl} class="text-link" tabindex="-1">Learn More</a>
                                </div>

                                </div>
                              )
                            })}


                        </div>

                    </div>
                </section>


                {/* <section class="page-section bg-dark-lighter light-content">
                    <div class="container relative">

                        <div class="text-center mb-80 mb-sm-50">
                            <h2 class="section-title">Features</h2>
                            <p class="section-title-descr">
                                What will you get if you choose us?
                            </p>
                        </div>


                        <div class="alt-service-grid">
                            <div class="row">


                                <div class="col-sm-6 col-md-6 col-lg-3">
                                    <div class="alt-service-item wow fadeScaleIn" data-wow-delay="0" data-wow-duration="1s">
                                        <div class="alt-service-icon">
                                            <i class="fa fa-paper-plane"></i>
                                        </div>
                                        <h3 class="alt-services-title">Branding</h3>
                                        <div class="alt-services-descr">Lorem ipsum dolor sit amet,  elit. Vitae gravida nibh maorbi dignissim nunc at risus convallis.</div>
                                    </div>
                                </div>



                                <div class="col-sm-6 col-md-6 col-lg-3">
                                    <div class="alt-service-item wow fadeScaleIn" data-wow-delay=".1s" data-wow-duration="1s">
                                        <div class="alt-service-icon">
                                            <i class="fa fa-cogs"></i>
                                        </div>
                                        <h3 class="alt-services-title">Web Design</h3>
                                        <div class="alt-services-descr">Vivamus neque orci, ultricies blandit ultrici vel, semper interdum elit, non placerat suscipit.</div>
                                    </div>
                                </div>



                                <div class="col-sm-6 col-md-6 col-lg-3">
                                    <div class="alt-service-item wow fadeScaleIn" data-wow-delay=".2s" data-wow-duration="1s">
                                        <div class="alt-service-icon">
                                            <i class="fa fa-feather"></i>
                                        </div>
                                        <h3 class="alt-services-title">Logo Design</h3>
                                        <div class="alt-services-descr">Lorem ipsum dolor sit amet,  elit. Vitae gravida nibh. Morbi nunc at risus convallis.</div>
                                    </div>
                                </div>



                                <div class="col-sm-6 col-md-6 col-lg-3">
                                    <div class="alt-service-item wow fadeScaleIn" data-wow-delay=".3s" data-wow-duration="1s">
                                        <div class="alt-service-icon">
                                            <i class="fa fa-life-ring"></i>
                                        </div>
                                        <h3 class="alt-services-title">Support</h3>
                                        <div class="alt-services-descr">Semper interdum ultricies elit, non placerat nisi suscipit. Dignissim nunc at risus convallis.</div>
                                    </div>
                                </div>


                            </div>
                        </div>


                    </div>
                </section> */}









                <section class="page-section light-content bg-dark bg-dark-alfa-70" data-background="/asset/images/hux_bg1.jpeg">
                    <div class="container relative">

                        <div class="wow fadeInUpShort">
                            <div class="item-carousel owl-carousel">


                                <div class="features-item">
                                    <div class="features-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M17 12c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.687 6-6-2.687-6-6-6zm.5 8.474v.526h-.5v-.499c-.518-.009-1.053-.132-1.5-.363l.228-.822c.478.186 1.114.383 1.612.27.574-.13.692-.721.057-1.005-.465-.217-1.889-.402-1.889-1.622 0-.681.52-1.292 1.492-1.425v-.534h.5v.509c.362.01.768.073 1.221.21l-.181.824c-.384-.135-.808-.257-1.222-.232-.744.043-.81.688-.29.958.856.402 1.972.7 1.972 1.773.001.858-.672 1.315-1.5 1.432zm1.624-10.179c1.132-.223 2.162-.626 2.876-1.197v.652c0 .499-.386.955-1.007 1.328-.581-.337-1.208-.6-1.869-.783zm-2.124-5.795c2.673 0 5-1.007 5-2.25s-2.327-2.25-5-2.25c-2.672 0-5 1.007-5 2.25s2.328 2.25 5 2.25zm.093-2.009c-.299-.09-1.214-.166-1.214-.675 0-.284.334-.537.958-.593v-.223h.321v.211c.234.005.494.03.784.09l-.116.342c-.221-.051-.467-.099-.708-.099l-.072.001c-.482.02-.521.287-.188.399.547.169 1.267.292 1.267.74 0 .357-.434.548-.967.596v.22h-.321v-.208c-.328-.003-.676-.056-.962-.152l.147-.343c.244.063.552.126.828.126l.208-.014c.369-.053.443-.3.035-.418zm-11.093 13.009c1.445 0 2.775-.301 3.705-.768.311-.69.714-1.329 1.198-1.899-.451-1.043-2.539-1.833-4.903-1.833-2.672 0-5 1.007-5 2.25s2.328 2.25 5 2.25zm.093-2.009c-.299-.09-1.214-.166-1.214-.675 0-.284.335-.537.958-.593v-.223h.321v.211c.234.005.494.03.784.09l-.117.342c-.22-.051-.466-.099-.707-.099l-.072.001c-.482.02-.52.287-.188.399.547.169 1.267.292 1.267.74 0 .357-.434.548-.967.596v.22h-.321v-.208c-.329-.003-.676-.056-.962-.152l.147-.343c.244.063.552.126.828.126l.208-.014c.368-.053.443-.3.035-.418zm4.003 8.531c-.919.59-2.44.978-4.096.978-2.672 0-5-1.007-5-2.25v-.652c1.146.918 3.109 1.402 5 1.402 1.236 0 2.499-.211 3.549-.611.153.394.336.773.547 1.133zm-9.096-3.772v-.651c1.146.917 3.109 1.401 5 1.401 1.039 0 2.094-.151 3.028-.435.033.469.107.926.218 1.37-.888.347-2.024.565-3.246.565-2.672 0-5-1.007-5-2.25zm0-2.5v-.652c1.146.918 3.109 1.402 5 1.402 1.127 0 2.275-.176 3.266-.509-.128.493-.21 1.002-.241 1.526-.854.298-1.903.483-3.025.483-2.672 0-5-1.007-5-2.25zm11-11v-.652c1.146.918 3.109 1.402 5 1.402 1.892 0 3.854-.484 5-1.402v.652c0 1.243-2.327 2.25-5 2.25-2.672 0-5-1.007-5-2.25zm0 5v-.652c.713.571 1.744.974 2.876 1.197-.661.183-1.287.446-1.868.783-.622-.373-1.008-.829-1.008-1.328zm0-2.5v-.651c1.146.917 3.109 1.401 5 1.401 1.892 0 3.854-.484 5-1.401v.651c0 1.243-2.327 2.25-5 2.25-2.672 0-5-1.007-5-2.25z"/></svg>
                                    </div>
                                    <div class="features-title">
                                        Hemat
                                    </div>
                                    <div class="features-descr">
                                        Kualitas kelas dunia dengan harga terjangkau
                                    </div>
                                </div>



                                <div class="features-item">
                                    <div class="features-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M18.885 3.515c-4.617-4.618-12.056-4.676-16.756-.195l-2.129-2.258v7.938h7.484l-2.066-2.191c2.82-2.706 7.297-2.676 10.073.1 4.341 4.341 1.737 12.291-5.491 12.291v4.8c3.708 0 6.614-1.244 8.885-3.515 4.686-4.686 4.686-12.284 0-16.97z"/></svg>
                                    </div>
                                    <div class="features-title">
                                        Retur Tanpa Ribet
                                    </div>
                                    <div class="features-descr">
                                        Barang rusak? Tidak sesuai? Kami ganti.
                                    </div>
                                </div>



                                <div class="features-item">
                                    <div class="features-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M19.5 10c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5 5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1zm-6.527 4.593c-1.108 1.086-2.275 2.219-3.473 3.407-6.43-6.381-12-11.147-12-15.808 0-6.769 8.852-8.346 12-2.944 3.125-5.362 12-3.848 12 2.944 0 .746-.156 1.496-.423 2.253-1.116-.902-2.534-1.445-4.077-1.445-3.584 0-6.5 2.916-6.5 6.5 0 2.063.97 3.901 2.473 5.093z"/></svg>
                                    </div>
                                    <div class="features-title">
                                        Dicintai Banyak Orang
                                    </div>
                                    <div class="features-descr">
                                        Kami yakin dengan produk dan pelayanan kami, anda tidak akan kecewa.
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                </section>




                {/* <section class="small-section bg-dark bg-dark-alfa-70 bg-scroll bg-position-top light-content" data-background="/asset/images/full-width-images/section-bg-3.jpg">
                    <div class="container relative">

                        <form id="mailchimp" class="form wow fadeInUpShort">
                            <div class="row">
                                <div class="col-md-8 offset-md-2">

                                    <div class="newsletter-label d-flex mb-50 mb-sm-20">
                                        <div class="newsletter-label-icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M1.999 1v7.269l-2 1.456v13.275h24.001v-13.275l-2.001-1.453v-7.272h-20zm1 11.234v-10.234h18v10.233l-9 5.766-9-5.765zm19 .54v-3.17l1.001.764v11.632h-22.001v-11.641l1-.707.063 3.134 9.937 6.413 10-6.425zm-14.305-6.752l-2.694.496 1.888 1.986-.361 2.716 2.472-1.182 2.473 1.182-.361-2.716 1.888-1.986-2.695-.496-1.305-2.41-1.305 2.41zm.248 2.139l-.945-.994 1.349-.249.653-1.206.654 1.206 1.349.249-.945.994.18 1.36-1.238-.591-1.238.591.181-1.36zm6.058-3.078h4.999v-1h-4.999v1zm0 2h4.999v-1h-4.999v1zm0 2h4.999v-1h-4.999v1zm0 2h3v-1h-3v1z"/></svg>
                                        </div>
                                        <h2 class="newsletter-label-text">
                                            Stay informed with&nbsp;our newsletter
                                        </h2>
                                    </div>

                                    <div class="d-sm-flex justify-content-between mb-20">
                                        <input placeholder="Your Email" class="newsletter-field input-lg round" type="email" pattern=".{5,100}" required aria-required="true"/>
                                        <button type="submit" aria-controls="subscribe-result" class="newsletter-button btn btn-mod btn-w btn-large btn-round">
                                            Subscribe Now
                                        </button>
                                    </div>

                                    <div class="form-tip">
                                        Proin fringilla augue at maximus vestibulum <a href="#">Terms & Conditions</a>.
                                    </div>""

                                    <div id="subscribe-result" role="region" aria-live="polite" aria-atomic="true"></div>

                                </div>
                            </div>
                        </form>

                    </div>
                </section> */}




                <section class="page-section bg-dark-lighter light-content" id="contact">
                    <div class="container relative">

                        <div class="text-center mb-80 mb-sm-50">
                            <h2 class="section-title">Contact</h2>
                            <p class="section-title-descr">
                                We’re available for the new projects
                            </p>
                        </div>

                        <div class="row mb-60 mb-xs-40">

                            <div class="col-md-10 offset-md-1">
                                <div class="row">


                                    <div class="col-sm-6 col-lg-4 pb-20">
                                        <div class="contact-item wow fadeScaleIn" data-wow-delay="0" data-wow-duration="1s">
                                            <div class="ci-icon">
                                                <i class="fa fa-phone-alt"></i>
                                            </div>
                                            <div class="ci-title">
                                                Call Us
                                            </div>
                                            <div class="ci-text">
                                                {page.waNum}
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-sm-6 col-lg-4 pb-20">
                                        <div class="contact-item wow fadeScaleIn" data-wow-delay=".1s" data-wow-duration="1s">
                                            <div class="ci-icon">
                                                <i class="fa fa-map-marker-alt"></i>
                                            </div>
                                            <div class="ci-title">
                                                Address
                                            </div>
                                            <div class="ci-text">
                                                Pulogadung, Jakarta Timur
                                            </div>
                                            {/* <div class="ci-link">
                                                <a href="/asset/https://goo.gl/maps/7Vw1PBhxx5BaXStr8" target="_blank">See on the Map</a>
                                            </div> */}
                                        </div>
                                    </div>



                                    <div class="col-sm-6 col-lg-4 pb-20">
                                        <div class="contact-item wow fadeScaleIn" data-wow-delay=".2s" data-wow-duration="1s">
                                            <div class="ci-icon">
                                                <i class="fa fa-envelope"></i>
                                            </div>
                                            <div class="ci-title">
                                                Email
                                            </div>
                                            <div class="ci-text">
                                                {page.email}
                                            </div>
                                            <div class="ci-link">
                                                <a href={`mailto:${page.email}`}>Say Hello</a>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>

                    </div>
                </section>




                {/* <section class="small-section bg-dark light-content">
                    <div class="container relative">
                        <div class="row wow fadeInUpShort">
                            <div class="col-md-8 offset-md-2 text-center">
                                <h3 class="call-action-1-heading">Want to discuss your new project?</h3>
                                <div class="call-action-1-decription mb-60 mb-sm-30">
                                    Proin fringilla augue at maximus vestibulum. Nam pulvinar vitae neque et porttitor. Integer non dapibus diam, ac eleifend lectus. Duis placerat ex gravida nibh tristique ultricies eros lorem blandit.
                                </div>

                                <div class="local-scroll">
                                    <a href="/asset/pages-contact-1-dark.html" class="btn btn-mod btn-w btn-large btn-round">Let's Talk</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}


            </main>


            <footer class="page-section bg-dark light-content footer pb-100 pb-sm-50">
                <div class="container">


                    <div class="footer-social-links mb-90 mb-xs-40">
                        <a href={page.instaStoreUrl} title="Instagram" target="_blank"><i class="fab fa-instagram"></i> <span class="sr-only">Instagram Account</span></a>
                    </div>



                    <div class="footer-text">


                        <div class="footer-copy">
                            <a href="/asset/index.html">{`© ${page.companyName} ${new Date().getFullYear()}`}</a>
                        </div>


                        <div class="footer-made">
                            Made with love for great people.
                        </div>

                    </div>


                 </div>


                 <div class="local-scroll">
                     <a href="#top" class="link-to-top"><i class="link-to-top-icon"></i></a>
                 </div>


            </footer>


        </div>

    </Layout>
  );
};

export default HomePageTemplate;

const InstaFeed = () => {
  return (
    <div id="instagramFeed" className="full-width">
      <div class="instagram_gallery">
        <a
          href="https://www.instagram.com/p/Bh-P3IoDxyB"
          rel="noopener"
          target="_blank"
        >
          <img src="..." alt="instagram instagram image 0" />
        </a>
        ...
      </div>
    </div>
  );
};

export const pageQuery = graphql`
  query IndexPageQuery {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    markdownRemark(frontmatter: { id: { eq: "home" } }) {
      frontmatter {
        templateKey
        logo
        companyName
        waNum
        waMessage
        email
        instaStoreUrl
        tokopediaUrl
        companyAddress
        messageParagraph {
          messageBody
          messageHeader
        }
        testimonials {
          text
          name
        }
        galleryvideos {
          title
          url
          image
        }
        galleryimages {
          title
          image
        }
        products {
          image
          productUrl
          name
          description
        }
        productGallery {
          label
          desc
          image
        }
        featuresGallery {
          label
          desc
          image
        }
        peopleGallery {
          label
          desc
          image
        }
        tutorial {
          title
          desc
          thumbnail
          video
        }
        tutorialMainImage
        id
        videoUrl
        videoThumbnail
        hWImage1
        hWImage2
        ttcsImage1
        ttcsImage2
      }
    }
    blog:allMarkdownRemark(filter: {frontmatter: {type: {eq: "blog"}}}) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "DD MMMM YYYY")
            mainImage
            intro
          }
        }
      }
    }
    allMarkdownRemark(
      filter: {
        frontmatter: { type: { eq: "product" } }
      }
    ) {
      edges {
        node {
          html
          frontmatter {
            name
            discountedPrice
            price
            description
            date(locale: "id")
            thumbnail
            images {
              image
            }
            tag
            redLabel
            blackLabel
            tokpedUrl
            instaUrl
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
